import { useState, useCallback, useMemo, useEffect, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { addGeoTagLocation, deleteGeoTagLocation, getGeoTagLocation, getGeoTagRegion, getIisActivateLocation } from './Services/AttendanceService';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { GoogleMap, useJsApiLoader, Marker, Circle, useLoadScript, Autocomplete } from "@react-google-maps/api";
import { useRef } from "react";
import { Paginator } from 'primereact/paginator';
import { GetMasterTypeData } from '../../../Services/Global-Services/GlobalServices';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';

const Geotag_Locations = () => {
  const [locations, setLocations] = useState([]);
  const [filteredLocs, setFilteredLocs] = useState([]);
  const [view, setView] = useState('grid');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [editTargetId, setEditTargetId] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [mapCenter, setMapCenter] = useState({ lat: 28.6139, lng: 77.2090 }); // default Delhi
  const [marker, setMarker] = useState(null);
  const autoCompleteRef = useRef(null);
  const libraries = ["places"];
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [zoneCategoryType, setZoneCategoryType] = useState([])
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [geoTagRegionType, setGeoTagRegionType] = useState([]);
  const [loading, setLoading] = useState(false);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "");
  const [showpermission, setShowpermission] = useState(false)
  const [locationType, setLocationType] = useState(1);
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w',
    libraries
  })


  useEffect(() => {
    let data = [...locations];
    if (locationType !== null) {
      data = locations.filter(loc => Number(loc.MyLocation) == locationType);
    }

    // Zone filter
    if (selectedZone) {
      data = locations.filter(loc => Number(loc.ZoneId) == Number(selectedZone));
    }

    // ✅ Region filter (ADD THIS)
    if (selectedRegion) {
      data = locations.filter(loc => Number(loc.RegionId) == Number(selectedRegion));
    }

    // Status filter
    if (selectedStatus !== "") {
      const statusBool = selectedStatus === "true";
      data = locations.filter(loc => loc.LocationStatus === statusBool);
    }

    // Search filter
    if (searchValue) {
      data = locations.filter(loc =>
        loc.LocationName?.toLowerCase().includes(searchValue.toLowerCase()) ||
        loc.Address?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    setFilteredLocs(data);
  }, [locations, selectedZone, selectedRegion, selectedStatus, searchValue, locationType]);

  // run once
  useEffect(() => {
    permissionAwardList();
    getMasterTicketCategory();
    getGeoTagRegionCategory();
  }, []);

  // run on pagination/search
  useEffect(() => {
    gettGeoTagLocationList();
  }, [first, rows, searchValue]);

  const permissionAwardList = () => {
    const hasPermission = userPermissions?.some(
      (p) => p.PermissionName === "GeoTag.Manage"
    );
    setShowpermission(hasPermission);
  };

  const clearLocFilters = () => {
    setSelectedZone("");
    setSelectedRegion("");
    setSelectedStatus("");
    setSearchValue("");
    setFirst(0);
    setLocationType(1);
  };

  const normalizeText = (value) => {
    return String(value || '').trim().toLowerCase();
  };

  const findMatchingOption = (text, items, labelKey) => {
    if (!text || !items?.length) return null;
    const normalized = normalizeText(text);
    return items.find((item) => {
      const label = normalizeText(item[labelKey]);
      return label && normalized.includes(label);
    });
  };

  const getLocationCodeFromName = (name) => {
    if (!name) return '';
    return name
      .toUpperCase()
      .replace(/[^A-Z0-9\s]/g, '');
  };

  const getMatchedZoneAndRegion = (address) => {
    const matchText = Array.isArray(address) ? address.join(' ') : address;
    const bestZone = findMatchingOption(matchText, zoneCategoryType, 'Name');
    const bestRegion = findMatchingOption(matchText, geoTagRegionType, 'Name');
    return {
      zoneId: bestZone?.Id || '',
      regionId: bestRegion?.RegionId || ''
    };
  };

  const getStateFromPlace = (place) => {
    const stateComp = place.address_components?.find(comp =>
      comp.types.includes("administrative_area_level_1")
    );
    return stateComp?.long_name || "";
  };

  const onPlaceChanged = async () => {
    const place = autoCompleteRef.current.getPlace();
    if (!place || !place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const address = place.formatted_address;

    // ✅ place.name = actual establishment name user selected
    const suggestedName =
      place.name ||
      place.address_components?.[0]?.long_name ||
      address.split(",")[0] ||
      "";

    setMapCenter({ lat, lng });
    setMarker({ lat, lng });

    tagLocationForm.setFieldValue("Address", address);
    tagLocationForm.setFieldValue("Latitude", lat);
    tagLocationForm.setFieldValue("Longitude", lng);
    tagLocationForm.setFieldValue("LocationName", suggestedName);
    tagLocationForm.setFieldValue("LocationTitle", place.name || "");
    // ✅ Try plus_code from place object first
    let suggestedCode = "";
    const rawPlusCode =
      place.plus_code?.compound_code ||
      place.plus_code?.global_code ||
      "";

    if (rawPlusCode) {
      suggestedCode = rawPlusCode.split(" ")[0].trim(); // "J9FJ+JP"
    } else {
      // ✅ Fallback: call Geocoding API with lat/lng — it ALWAYS returns plus_code
      try {
        const res = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w`
        );
        const data = await res.json();
        const geoPlusCode =
          data.plus_code?.compound_code ||
          data.plus_code?.global_code ||
          "";
        suggestedCode = geoPlusCode
          ? geoPlusCode.split(" ")[0].trim()   // "J9FJ+JP"
          : suggestedName.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8); // last resort
      } catch {
        suggestedCode = suggestedName.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
      }
    }

    tagLocationForm.setFieldValue("LocationCode", suggestedCode);
  };

  const geocodeTypedAddress = async (address) => {
    if (!address || !isLoaded || !window.google?.maps?.Geocoder) return null;

    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results?.[0]) {
          const location = results[0].geometry.location;
          resolve({
            lat: location.lat(),
            lng: location.lng(),
            formatted_address: results[0].formatted_address,
            raw_name: results[0].address_components?.[0]?.long_name || '',
            address_components: results[0].address_components || []
          });
        } else {
          resolve(null);
        }
      });
    });
  };

  const getStateFromComponents = (components) => {
    const stateComp = components?.find(comp =>
      comp.types.includes("administrative_area_level_1")
    );
    return stateComp?.long_name || "";
  };



  const handleAddressBlur = async (e) => {
    tagLocationForm.handleBlur(e);
    const address = e.target.value?.trim();
    if (!address) return;

    const geo = await geocodeTypedAddress(address);
    if (!geo) return;

    const getLocalityName = (components) => {
      const order = [
        "establishment", "point_of_interest",
        "sublocality_level_1", "sublocality",
        "locality", "administrative_area_level_2",
      ];
      for (const type of order) {
        const comp = components?.find(c => c.types.includes(type));
        if (comp) return comp.long_name;
      }
      return components?.[0]?.long_name || "";
    };

    const suggestedName = getLocalityName(geo.address_components);

    // ✅ Geocoding API response has plus_code at top level — pass full response
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${geo.lat},${geo.lng}&key=AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w`
    );
    const geoData = await res.json();
    const rawPlusCode =
      geoData.plus_code?.compound_code ||
      geoData.plus_code?.global_code ||
      "";
    const suggestedCode = rawPlusCode
      ? rawPlusCode.split(" ")[0].trim()
      : suggestedName.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);

    const suggestedRadius = tagLocationForm.values.RadiusMetres || 100;
    const addressText = [geo.formatted_address, ...geo.address_components.map(c => c.long_name)].join(' ');
    const { zoneId, regionId } = getMatchedZoneAndRegion(addressText);

    setMapCenter({ lat: geo.lat, lng: geo.lng });
    setMarker({ lat: geo.lat, lng: geo.lng });
    tagLocationForm.setFieldValue('Address', geo.formatted_address);
    tagLocationForm.setFieldValue('Latitude', geo.lat);
    tagLocationForm.setFieldValue('Longitude', geo.lng);
    tagLocationForm.setFieldValue('LocationName', suggestedName);
    tagLocationForm.setFieldValue('LocationCode', suggestedCode);
    tagLocationForm.setFieldValue('RadiusMetres', suggestedRadius);
    if (zoneId) tagLocationForm.setFieldValue('Zone', zoneId);
    if (regionId) tagLocationForm.setFieldValue('Region', regionId);
  };

  const handleMapClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setMarker({ lat, lng });
    setMapCenter({ lat, lng });

    tagLocationForm.setFieldValue("Latitude", lat);
    tagLocationForm.setFieldValue("Longitude", lng);

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w`
      );
      const data = await res.json();

      if (data.results?.length > 0) {
        const result = data.results[0];
        tagLocationForm.setFieldValue("Address", result.formatted_address);

        const rawPlusCode =
          data.plus_code?.compound_code ||
          data.plus_code?.global_code ||
          "";

        const suggestedCode = rawPlusCode
          ? rawPlusCode.split(" ")[0].trim()
          : "";

        const getLocalityName = (components) => {
          const order = [
            "establishment", "point_of_interest",
            "sublocality_level_1", "sublocality",
            "locality", "administrative_area_level_2",
          ];
          for (const type of order) {
            const comp = components?.find(c => c.types.includes(type));
            if (comp) return comp.long_name;
          }
          return components?.[0]?.long_name || "";
        };

        const localityName = getLocalityName(result.address_components);
        tagLocationForm.setFieldValue("LocationName", localityName);
        tagLocationForm.setFieldValue("LocationCode", suggestedCode || localityName.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8));
      }
    } catch (err) {
      console.error("Map click geocode error:", err);
    }
  };


  async function getGeoTagRegionCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgRegion",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setGeoTagRegionType(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgZone",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setZoneCategoryType(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }


  async function gettGeoTagLocationList() {
    setLoading(true);
    const pageNumber = Math.floor(first / rows) + 1;
    const params = {
      Id: 0,
      PageNumber: pageNumber,
      PageSize: rows,
      GUID: "",
      Search: searchValue
    };

    try {
      const response = await getGeoTagLocation(params);
      setLoading(false);
      setLocations(response?.Data || []);
      setTotalRecords(response?.Data?.[0]?.TotalRecords || 0);
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLoading(false);
    }
  }

  const tagLocationValidation = Yup.object().shape({
    // LocationTitle: Yup.string().required("Location Title is required"),
    LocationName: Yup.string().required("Location Name is required"),
    Address: Yup.string().required("Address is required"),
    Latitude: Yup.number().typeError("Latitude must be a number").required("Latitude is required"),
    Longitude: Yup.number().typeError("Longitude must be a number").required("Longitude is required"),
    RadiusMetres: Yup.number().required("Radius is required").min(50).max(5000),
    Zone: Yup.string().required("Zone is required"),
    Region: Yup.string().required("Region is required"),
  });

  const tagLocationForm = useFormik({
    initialValues: {
      LocationName: "",
      LocationCode: "",
      Address: "",
      Latitude: "",
      Longitude: "",
      RadiusMetres: "",
      Zone: "",
      Region: "",
      LocationTitle: "",
      Description: ""
    },
    validationSchema: tagLocationValidation,
    onSubmit: async (values) => {

      setLoading(true);

      const body = {
        Id: editTargetId ? editTargetId : 0,
        // OrgId: userDetails?.OrgId ?? 0,
        LocationName: values.LocationName,
        LocationCode: values.LocationCode,
        Address: values.Address,
        ZoneId: Number(values.Zone),
        RegionId: Number(values.Region),
        Latitude: Number(values.Latitude),
        Longitude: Number(values.Longitude),
        LocationStatus: values?.LocationStatus ?? true,
        RadiusMetres: Number(values.RadiusMetres),
        // ClientProject: values.Project,
        Notes: values.Description,
        LocationTitle: values.LocationTitle

      };

      try {
        await addGeoTagLocation(body);
        await gettGeoTagLocationList();

        setShowModal(false);
        setEditTargetId(null);
        tagLocationForm.resetForm();
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });


  const showFieldError = (field) => !!tagLocationForm.errors[field] && (tagLocationForm.touched[field] || tagLocationForm.submitCount > 0);

  const handleExport = () => {
    const dataToExport = filteredLocs.length ? filteredLocs : locations;

    if (!dataToExport.length) {
      alert("No data to export");
      return;
    }

    const headers = [
      "Location Name",
      "Location Code",
      "Address",
      "Zone",
      "Region",
      "Latitude",
      "Longitude",
      "Radius (m)",
      "Employees",
      "Status"
    ];

    const rows = dataToExport.map(loc => [
      loc.LocationName,
      loc.LocationCode,
      loc.Address,
      loc.ZoneId,
      loc.RegionId,
      loc.Latitude,
      loc.Longitude,
      loc.RadiusMetres,
      loc.empCount ?? 0,
      loc.LocationStatus
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map(e => e.map(v => `"${v ?? ""}"`).join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "GeoTag_Locations.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Modal Handlers
  const openLocationModal = useCallback((editData) => {
    setEditTargetId(editData?.Id || null);
    if (editData) {
      const lat = Number(editData.Latitude);
      const lng = Number(editData.Longitude);
      setMapCenter({ lat, lng });
      setMarker({ lat, lng });
      tagLocationForm.setValues({
        LocationName: editData.LocationName || "",
        LocationCode: editData.LocationCode || "",
        Address: editData.Address || "",
        Latitude: lat,
        Longitude: lng,
        RadiusMetres: editData.RadiusMetres || "",
        LocationStatus: editData.LocationStatus ?? true,
        Zone: editData.ZoneId || "",
        Region: editData.RegionId || "",
        LocationTitle: editData.LocationTitle || "",
        Description: editData.Notes || ""
      });
    } else {
      tagLocationForm.resetForm();
    }
    setShowModal(true);
  }, [tagLocationForm]);

  const DeleteGeoLocation = (id) => {
    setShowDeleteModal(true);
    setDeleteTargetId(id);
  }

  const confirmDelete = useCallback(async () => {
    setLoading(true);
    const body = {
      RequestId: deleteTargetId,
      UserId: userDetails?.EmpId ?? 0,
    };
    try {
      await deleteGeoTagLocation(body);
      await gettGeoTagLocationList();
      setLoading(false);
      setShowDeleteModal(false);
      setDeleteTargetId(null);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }, [deleteTargetId]);


  const toggleStatus = useCallback(async (id) => {
    setLoading(true);

    try {
      await getIisActivateLocation({ Id: id });
      await gettGeoTagLocationList();

    } catch (error) {
      console.error("Toggle status error:", error);
    } finally {
      setLoading(false);
    }
  }, [first, rows, searchValue]);

  return (
    <div>
      <div className="container-fluid">
        {/* Breadcrumb & Header - Unchanged */}
        <div style={{ fontSize: '.76rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
          <Link to="/attendance-register" style={{ color: 'var(--primary)', textDecoration: 'none' }}>Attendance</Link>
          <i className="fa fa-chevron-right" style={{ fontSize: '.6rem', margin: '0 .4rem' }}></i>
          Geo Tag Locations
        </div>

        <div className="page-head">
          <div>
            <h2>Geo Tag Locations</h2>
            <p>Define geo-fenced areas where employees can mark their attendance from mobile</p>
          </div>
          <div className="head-actions">
            {showpermission && (
              <>
                <button className="btn-og btn-og-secondary btn-og-sm" onClick={handleExport}>
                  <i className="fa fa-download"></i> Export
                </button>
                <button className="btn-og theme-color btn-og-sm" onClick={() => openLocationModal()}>
                  <i className="fa fa-plus"></i> Add Location
                </button></>
            )}
            <Link to="/My-Attendance">
              <button className="btn-og btn-og-secondary btn-og-sm" style={{ justifyContent: 'flex-start' }}>
                Back
              </button>
            </Link>
          </div>
        </div>

        {/* Stats - Unchanged */}
        <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(3,1fr)' }}>
          <div className="stat-card sc-total"><div className="sc-label">Total Locations</div><div className="sc-value">{locations.length}</div><i className="fa fa-map-marker sc-icon"></i></div>
          <div className="stat-card sc-present"><div className="sc-label">Active</div><div className="sc-value">{locations.filter(l => l.LocationStatus === true).length}
          </div><i className="fa fa-check-circle sc-icon"></i></div>
          <div className="stat-card sc-absent"><div className="sc-label">Inactive</div><div className="sc-value"> {locations.filter(l => l.LocationStatus === false).length}</div><i className="fa fa-times-circle sc-icon"></i></div>
          {/* <div className="stat-card sc-leave"><div className="sc-label">Employees Mapped</div><div className="sc-value">{locations.reduce((sum, l) => sum + l.empCount, 0)}</div><div className="sc-sub">Total employees</div><i className="fa fa-users sc-icon"></i></div> */}
        </div>

        {/* Filter Bar - Unchanged (except onChange now points to fixed function) */}
        <div className="filter-bar">
          {/* <span className="filter-label"><i className="fa fa-filter"></i>&nbsp; Filters</span> */}
          <select
            className="og-select"
            value={selectedZone}
            onChange={(e) => {
              setSelectedZone(e.target.value);
              setSelectedRegion("");
              setFirst(0);
            }}
            style={{ minWidth: '130px' }}
          >
            <option value="">All Zones</option>
            {zoneCategoryType.map((zone) => (
              <option key={zone.Id} value={zone.Id}>
                {zone.Name}
              </option>
            ))}
          </select>
          <select
            className="og-select"
            value={selectedRegion}
            disabled={!selectedZone}
            onChange={(e) => {
              setSelectedRegion(e.target.value);
              setFirst(0);
            }}
          >
            <option value="">All Region</option>
            {geoTagRegionType
              .filter(r => Number(r.Code) == Number(selectedZone)) // ✅ FIXED
              .map(region => (
                <option key={region.Id} value={region.Id}>
                  {region.Name}
                </option>
              ))}
          </select>
          <select
            className="og-select"
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
              setFirst(0);
            }}
            style={{ minWidth: '130px' }}
          >
            <option value="">All Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          <div className="search-wrap">
            <i className="fa fa-search"></i>
            <input
              type="text"
              className="og-input w-100"
              placeholder="Search location…"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setFirst(0);
              }}
            />
          </div>
          <div className="divider"></div>
          <button className="btn-og btn-og-secondary btn-og-sm" onClick={clearLocFilters}>
            <i className="fa fa-times"></i> Clear
          </button>

          <div style={{ marginLeft: 'auto', display: 'flex', gap: '.3rem' }}>
            <button className="btn-og btn-og-secondary btn-og-sm" onClick={() => setView('grid')}
              style={view === 'grid' ? { background: 'var(--primary)', color: '#fff', borderColor: 'var(--primary)' } : {}}>
              <i className="fa fa-th-large"></i>
            </button>
            <button className="btn-og btn-og-secondary btn-og-sm" onClick={() => setView('list')}
              style={view === 'list' ? { background: 'var(--primary)', color: '#fff', borderColor: 'var(--primary)' } : {}}>
              <i className="fa fa-list"></i>
            </button>
          </div>
        </div>
        <div className="locations-tab">
          <ul>
            <li
              className={locationType === 1 ? 'active-tab' : ''}
              onClick={() => setLocationType(1)}
            >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="5" r="2.5" fill="currentColor"></circle>
                <path d="M2.5 14c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" fill="none"></path>
              </svg>
              My Location
            </li>

            <li
              className={locationType === 0 ? 'active-tab' : ''}
              onClick={() => setLocationType(0)}
            >
              Other's Location
            </li>
          </ul>
        </div>
        {/* Grid View - Unchanged */}
        {view === 'grid' && (
          <div id="gridView">
            <div id="locGrid" style={{ display: 'grid', paddingBottom: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(304px, 1fr))', gap: '1rem' }}>
              {(filteredLocs.length > 0 || selectedZone || selectedRegion || selectedStatus || searchValue
                ? filteredLocs
                : locations).length === 0 ? (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
                  <i className="fa fa-map-o" style={{ fontSize: '2rem', marginBottom: '.5rem', display: 'block' }}></i>
                  No locations match current filters
                </div>
              ) : (
                (filteredLocs.length > 0 || selectedZone || selectedRegion || selectedStatus || searchValue
                  ? filteredLocs
                  : locations).map((loc) => (
                    <div className="location-card" key={loc.LocationCode}>
                      <div className="lc-head">
                        <div className="lc-icon">
                          <i className="fa fa-map-marker"></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="lc-name" title={loc.LocationName || "N/A"}>
                            {loc.LocationName || "N/A"}
                          </div>

                          <div className="lc-addr" title={loc.Address || "No Address"}>
                            <i className="fa fa-map-pin" style={{ marginRight: '.25rem', fontSize: '.65rem' }}></i>
                            {loc.Address || "No Address"}
                          </div>
                        </div>
                      </div>

                      <div className="lc-meta">
                        <span className="lc-tag">
                          <i className="fa fa-globe"></i>
                          {loc.ZoneName || "-"}
                        </span>

                        <span className="lc-tag">
                          <i className="fa fa-map-marker"></i>
                          {loc.RegionName || "-"}
                        </span>

                        <span className="lc-tag">
                          {loc.RadiusMetres || 0}m radius
                        </span>

                        <span className="emp-count-badge">
                          <i className="fa fa-users" style={{ fontSize: '.6rem' }}></i>
                          {loc.MappedEmployees ?? 0} employees
                        </span>
                        <span className='emp-code'>
                          <i className="fa fa-briefcase" style={{ marginRight: '.3rem' }}></i>
                          Code:<strong>{loc.LocationCode}</strong>
                          &nbsp;{loc.ClientProject && (
                            <>
                              {" | "}{loc.ClientProject}
                            </>
                          )}
                        </span>
                      </div>
                      {(showpermission && loc?.LocationStatus) && (
                        <div style={{ marginTop: '.65rem' }}>
                          <a
                            href={`/Geotag-Employee-Assignment/${loc.GUID}`}
                            className="btn-og btn-og-outline btn-og-xs"
                            style={{ textDecoration: 'none', width: '100%', justifyContent: 'center', display: 'flex' }}
                          >
                            <i className="fa fa-users"></i> Assign / Manage Employees </a>
                        </div>
                      )}
                      <div className="lc-status">
                        <span
                          className={`status-pill ${loc?.LocationStatus ? 'pill-active' : 'pill-inactive'}`}
                        >
                          <i className="fa fa-circle" style={{ fontSize: '.45rem' }}></i>
                          {loc?.LocationStatus ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                      {showpermission && (
                        <div className="lc-actions">
                          <button
                            type="button"
                            className="btn-og btn-og-primary btn-og-xs"
                            onClick={() => openLocationModal(loc)}
                          >
                            <i className="fa fa-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="btn-og btn-og-danger btn-og-xs"
                            onClick={() => DeleteGeoLocation(loc?.Id)}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                          <button
                            type="button"
                            className="btn-og btn-og-secondary btn-og-xs"
                            onClick={() => toggleStatus(loc.Id)}
                            title={loc?.LocationStatus ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`fa fa-${loc?.LocationStatus ? 'pause' : 'play'}`}></i>
                          </button>
                        </div>)}
                    </div>
                  ))
              )}
            </div>
            <div className="card">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        )}

        {/* List View - Unchanged (except pagination fix) */}
        {view === 'list' && (
          <div id="listView">
            <div className="og-card">
              <div className="og-card-header">
                <h5>All Geo Tag Locations</h5>
                <div className="sub">{filteredLocs.length} locations</div>
              </div>
              <table className="og-table" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th className='text-left'>Location Name</th>
                    <th className='text-left'>Address</th>
                    <th className='text-left'>Zone / Region</th>
                    <th className='text-left'>Radius</th>
                    <th className='text-left'>Employees</th>
                    <th className='text-left'>Status</th>
                    {showpermission && (
                      <th className='text-left'>Actions</th>)}
                  </tr>
                </thead>
                <tbody>
                  {(filteredLocs.length > 0 || selectedZone || selectedRegion || selectedStatus || searchValue
                    ? filteredLocs
                    : locations).map(loc => (
                      <tr key={loc.Id}>
                        <td className='text-left'><small style={{ color: 'var(--text-muted)' }}>{loc.LocationName}</small></td>
                        <td className='text-left' style={{ fontSize: '.77rem', color: 'var(--text-muted)' }}>{loc.Address}</td>
                        <td className='text-left'><span style={{ fontSize: '.77rem' }}>{loc.ZoneName} / {loc.RegionName}</span></td>
                        <td className='text-left'><span className="lc-tag" style={{ display: 'inline-flex', alignItems: 'baseline', gap: '5px' }}><i className="fa fa-circle-o"></i>{loc.RadiusMetres}m</span></td>
                        <td className='text-left'><span className="emp-count-badge"><i className="fa fa-users" style={{ fontSize: '.6rem' }}></i>{loc.MappedEmployees ?? 0}</span></td>
                        <td className='text-left'>
                          <span
                            className={`status-pill ${loc?.LocationStatus ? 'pill-active' : 'pill-inactive'}`}
                          >
                            <i className="fa fa-circle" style={{ fontSize: '.45rem' }}></i>
                            {loc?.LocationStatus ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        {showpermission && (
                          <td className='text-left'>
                            <div style={{ display: 'flex', gap: '.3rem' }}>
                              <button type="button" className="btn-og btn-og-primary btn-og-xs" onClick={() => openLocationModal(loc)}><i className="fa fa-pencil"></i></button>
                              <button type="button" className="btn-og btn-og-danger btn-og-xs" ><i className="fa fa-trash" onClick={() => DeleteGeoLocation(loc?.Id)}></i></button>
                              {/* <button type="button" className="btn-og btn-og-secondary btn-og-xs" onClick={() => toggleStatus(loc.Id)} title="Toggle Status"><i className="fa fa-power-off"></i></button> */}
                              <button
                                type="button"
                                className="btn-og btn-og-secondary btn-og-xs"
                                onClick={() => toggleStatus(loc.Id)}
                                title={loc?.LocationStatus ? 'Deactivate' : 'Activate'}
                              >
                                <i className={`fa fa-${loc?.LocationStatus ? 'pause' : 'play'}`}></i>
                              </button>
                            </div>
                          </td>)}
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="card">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={totalRecords}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                />              </div>

            </div>
          </div>
        )}
      </div>


      {showModal && (
        <div
          // className="og-modal-overlay" 
          onClick={() => setShowModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // zIndex: 2000
          }}
        >
          <div
            className="og-modal og-modal-lg"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              background: 'white',
              borderRadius: '12px',
              overflow: 'hidden'
            }}
          >
            <div className="og-modal-header">
              <i className="fa fa-map-marker" style={{ color: 'var(--primary)', fontSize: '1.1rem' }}></i>
              <h5>{editTargetId ? 'Edit Geo Tag Location' : 'Add Geo Tag Location'}</h5>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                <i className="fa fa-times"></i>
              </button>
            </div>

            <form onSubmit={tagLocationForm.handleSubmit}>
              <div className="og-modal-body modal-bx-scrollable">
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="og-label">Location Title</label>
                    <input
                      type="text"
                      className="og-input"
                      name="LocationTitle"
                      value={tagLocationForm.values.LocationTitle}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="og-label">Full Address <span className="req" style={{ color: 'red' }}>*</span></label>

                    <Autocomplete
                      onLoad={(ref) => (autoCompleteRef.current = ref)}
                      onPlaceChanged={onPlaceChanged}
                      fields={["place_id", "geometry", "name", "formatted_address", "address_components", "plus_code"]}
                    >
                      <input
                        type="text"
                        className="og-input"
                        name="Address"
                        value={tagLocationForm.values.Address}
                        onChange={tagLocationForm.handleChange}
                        onBlur={handleAddressBlur}
                      />
                    </Autocomplete>

                    {showFieldError('Address') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.Address}</small>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="og-label">Location Name <span className="req" style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className="og-input"
                      name="LocationName"
                      value={tagLocationForm.values.LocationName}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                    {showFieldError('LocationName') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.LocationName}</small>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="og-label">Location Code</label>
                    <input
                      type="text"
                      className="og-input"
                      name="LocationCode"
                      value={tagLocationForm.values.LocationCode}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                  </div>
                  <div className="form-group">
                    <label className="og-label">Zone <span className="req" style={{ color: 'red' }}>*</span></label>
                    <select
                      className="og-input"
                      name="Zone"
                      value={tagLocationForm.values.Zone}
                      onChange={(e) => {
                        tagLocationForm.handleChange(e);
                        tagLocationForm.setFieldValue("Region", ""); // ✅ reset region
                      }}
                      onBlur={tagLocationForm.handleBlur}
                    >
                      <option value="">Select Zone</option>
                      {zoneCategoryType.map((zone) => (
                        <option key={zone.Id} value={zone.Id}>
                          {zone.Name}
                        </option>
                      ))}
                    </select>
                    {showFieldError('Zone') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.Zone}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="og-label">Region <span className="req" style={{ color: 'red' }}>*</span></label>
                    <select
                      className="og-input"
                      name="Region"
                      value={tagLocationForm.values.Region}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                      disabled={!tagLocationForm.values.Zone}
                      style={{ opacity: !tagLocationForm.values.Zone ? 0.6 : 1 }}
                    >
                      <option value="">Select Region</option>
                      {geoTagRegionType
                        .filter(r => String(r.Code) === String(tagLocationForm.values.Zone))
                        .map((region) => (
                          <option key={region.Id} value={region.Id}>
                            {region.Name}
                          </option>
                        ))}
                    </select>
                    {showFieldError('Region') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.Region}</small>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="og-label">Latitude <span className="req" style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className="og-input"
                      name="Latitude"
                      value={tagLocationForm.values.Latitude}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                    {showFieldError('Latitude') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.Latitude}</small>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="og-label">Longitude <span className="req" style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className="og-input"
                      name="Longitude"
                      value={tagLocationForm.values.Longitude}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                    {showFieldError('Longitude') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.Longitude}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="og-label">Check-In Radius (metres) <span className="req" style={{ color: 'red' }}>*</span></label>
                    <input
                      type="number"
                      className="og-input"
                      name="RadiusMetres"
                      min="50"
                      max="5000"
                      value={tagLocationForm.values.RadiusMetres}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                    {showFieldError('RadiusMetres') && (
                      <small className="error" style={{ color: 'red' }}>{tagLocationForm.errors.RadiusMetres}</small>
                    )}
                    <div style={{ fontSize: '.71rem', color: 'var(--text-muted)', marginTop: '.3rem' }}>
                      <i className="fa fa-info-circle" style={{ marginRight: '.25rem' }}></i>
                      Min 50m · Max 5000m. Recommended: 100–500m
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <label className="og-label" style={{ alignSelf: 'flex-start' }}>Radius Preview</label>
                    <div style={{ position: 'relative', marginTop: '.5rem' }}>
                      <div
                        className="radius-ring"
                        style={{
                          width: Math.min(160, Math.max(80, tagLocationForm.values.RadiusMetres / 5 + 60)) + 'px',
                          height: Math.min(160, Math.max(80, tagLocationForm.values.RadiusMetres / 5 + 60)) + 'px'
                        }}
                      >
                        <div className="center-dot"></div>
                        <span className="radius-label">
                          {tagLocationForm.values.RadiusMetres || 0}m radius
                        </span>
                      </div>
                    </div>
                  </div>
                  <label className="og-label">Map Preview</label>
                  <div style={{ gridColumn: "1/-1", marginTop: "10px" }}>

                    {isLoaded && (
                      <GoogleMap
                        center={mapCenter}
                        zoom={15}
                        mapContainerStyle={{ width: "100%", height: "300px", borderRadius: "10px" }}
                        onClick={handleMapClick}
                        options={{
                          gestureHandling: "cooperative",
                          clickableIcons: false,   // ✅ prevents POI icons from stealing clicks
                        }}
                      >
                        {marker && (
                          <Marker
                            position={marker}
                            options={{ clickable: false }}   // ✅ marker won't steal map click
                          />
                        )}

                        {marker && tagLocationForm.values.RadiusMetres && (
                          <Circle
                            center={marker}
                            radius={Number(tagLocationForm.values.RadiusMetres)}
                            options={{
                              fillColor: "#4CAF50",
                              fillOpacity: 0.2,
                              strokeColor: "#4CAF50",
                              strokeOpacity: 0.8,
                              clickable: false,    // ✅ circle won't steal map click
                            }}
                          />
                        )}
                      </GoogleMap>
                    )}
                  </div>
                  {/* <div className="form-group">
                    <label className="og-label">Client / Project (Optional)</label>
                    <input
                      type="text"
                      className="og-input"
                      name="Project"
                      value={tagLocationForm.values.Project}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                  </div> */}
                  {/* <div className="form-group">
                  <label className="og-label">Status</label>
                  <select
                    className="og-select"
                    name="LocationStatus"
                    value={tagLocationForm.values.LocationStatus}
                    onChange={tagLocationForm.handleChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div> */}

                  <div className="form-group">
                    <label className="og-label">Notes / Description</label>
                    <textarea
                      type="text"
                      className="og-input"
                      name="Description"
                      value={tagLocationForm.values.Description}
                      onChange={tagLocationForm.handleChange}
                      onBlur={tagLocationForm.handleBlur}
                    />
                  </div>
                </div>
              </div>

              <div className="og-modal-footer">
                <button
                  type="button"
                  className="btn-og btn-og-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-og btn-og-primary">
                  <i className="fa fa-save"></i> Save Location
                </button>
              </div>
            </form>

          </div>
        </div>
      )}

      {/* Delete Modal */}
      {showDeleteModal && deleteTargetId && (
        <div
          // className="og-modal-overlay" 
          onClick={() => setShowDeleteModal(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // zIndex: 2000
          }}
        >
          <div
            className="og-modal og-modal-sm"
            onClick={(e) => e.stopPropagation()}
            style={{ position: 'relative', background: 'white', borderRadius: '12px' }}
          >
            <div className="og-modal-header">
              <i className="fa fa-exclamation-triangle" style={{ color: '#dc2626', fontSize: '1.1rem' }}></i>
              <h5>Delete Location</h5>
              <button className="modal-close" onClick={() => setShowDeleteModal(false)}>
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div className="og-modal-body">
              <p>
                Are you sure you want to delete <strong>
                  {locations.find(l => l.Id === deleteTargetId)?.LocationName}
                </strong>?
              </p>
              <p style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>
                This will unlink all employees associated with this location. This action cannot be undone.
              </p>
            </div>
            <div className="og-modal-footer">
              <button className="btn-og btn-og-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button className="btn-og btn-og-danger" onClick={confirmDelete}>
                <i className="fa fa-trash"></i> Delete Location
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {/* {showDeleteModal && deleteTargetId && (
        <div className="og-modal-overlay" onClick={() => setShowDeleteModal(false)} 
             style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000}}>
          <div className="og-modal og-modal-sm" onClick={(e) => e.stopPropagation()} 
               style={{position: 'relative', background: 'white'}}>
            <div className="og-modal-header">
              <i className="fa fa-exclamation-triangle" style={{color:'#dc2626', fontSize:'1.1rem'}}></i>
              <h5>Delete Location</h5>
              <button className="modal-close" onClick={() => setShowDeleteModal(false)}><i className="fa fa-times"></i></button>
            </div>
            <div className="og-modal-body">
              <p>Are you sure you want to delete <strong>{locations.find(l => l.id === deleteTargetId)?.name}</strong>?</p>
              <p style={{fontSize:'.8rem', color:'var(--text-muted)'}}>This will unlink all employees associated with this location. This action cannot be undone.</p>
            </div>
            <div className="og-modal-footer">
              <button className="btn-og btn-og-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button className="btn-og btn-og-danger" onClick={confirmDelete}>
                <i className="fa fa-trash"></i> Delete Location
              </button>
            </div>
          </div>
        </div>
      )} */}


      {loading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default Geotag_Locations;